// Briefing — read-only standalone view of the event briefing (Sophi App v2
// Piece 7). Replaces the Telegram group's pinned briefing message once the
// group surface goes away at cutover. Sourced from the same Firestore thread
// metadata that the chat uses (Asignaciones_Eventos.Briefing_Texto seeded at
// thread create), so it's available even if the staff hasn't opened the chat.
//
// Reachable from EventDetailModal → "📋 Briefing".

import { useEffect, useState } from 'preact/hooks';
import { getChatThread, type ChatThread } from '../lib/api';
import { Linkify } from '../components/Linkify';

interface BriefingProps {
  eventId: string;
  eventTitle?: string;
  onClose: () => void;
}

export function Briefing({ eventId, eventTitle, onClose }: BriefingProps) {
  const [thread, setThread] = useState<ChatThread | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const t = await getChatThread(eventId);
        setThread(t);
      } catch (e) {
        setError((e as Error).message);
      }
    })();
  }, [eventId]);

  return (
    <div class="event-chat-screen">
      <header class="event-chat-header">
        <button class="event-chat-back" onClick={onClose} aria-label="Cerrar">←</button>
        <div class="event-chat-titles">
          <div class="event-chat-title">📋 Briefing · {eventTitle || eventId}</div>
          <div class="event-chat-sub">Información del evento</div>
        </div>
      </header>

      <div class="briefing-body">
        {error && <div class="mireporte-error">⚠️ {error}</div>}
        {!thread && !error && <div class="loading"><span class="spinner" /></div>}
        {thread && !thread.briefing && (
          <div class="briefing-empty">
            <div class="briefing-empty-icon">📋</div>
            <h3>Sin briefing aún</h3>
            <p class="mireporte-meta">
              Operaciones todavía no publicó el briefing de este evento. Cuando esté listo, aparecerá aquí.
            </p>
          </div>
        )}
        {thread && thread.briefing && (
          <article class="briefing-content">
            <pre class="briefing-text"><Linkify text={thread.briefing} /></pre>
          </article>
        )}
      </div>
    </div>
  );
}
